import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/closeup-soldier-being-consoled-by-healthcare-workers-clinic_637285-5319.jpg';

function VeteransHealthWellness() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Veterans' Health and Wellness Services" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Veterans' Health and Wellness Services</h4>
              <p>
                This sub-department is committed to enhancing the health and wellness of veterans through tailored medical care, mental health support, and wellness programs.<br />
                Services include comprehensive physical health care, counseling, and support groups designed to address the unique needs of veterans.<br /><br />
                Our goal is to provide veterans with the resources and care they need to lead healthy, fulfilling lives after their service.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Comprehensive Medical Care</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Mental Health Counseling</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Veteran Wellness Programs</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to ensuring that veterans receive the highest quality care and support, empowering them to lead healthy and fulfilling lives.
              </p>
            </div>
            <div>
              <Link to="/department/veterans">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default VeteransHealthWellness;
